import React, { useState } from 'react';
import { Box, Button, Typography, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AdminLogin from './AdminLogin';
import Logo from '../assets/MOA_Logo-removebg-preview.png';

const Welcome = () => {
  const [openLogin, setOpenLogin] = useState(false);

  const handleLoginOpen = () => {
    setOpenLogin(true);
  };

  const handleLoginClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setOpenLogin(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh',
        background: 'linear-gradient(120deg, #FFFFFF 0%, #F0FDF4 100%)',
        overflow: 'hidden',
        padding: 0,
        margin: 0,
      }}
    >
      {/* Left Side with Image */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 2,
        }}
      >
        <img
          src={Logo}
          alt="Procureria Logo"
          style={{
            width: '80%',
            height: 'auto',
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%',
            objectFit: 'cover',
          }}
        />
      </Box>

      {/* Right Side with Content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: 3,
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            mb: 4,
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
            fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem' },
          }}
        >
          Welcome to Procureria Admin
        </Typography>
        
        <Typography
          variant="h5"
          sx={{
            mb: 6,
            maxWidth: '800px',
            lineHeight: 1.6,
            opacity: 0.9,
            fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
          }}
        >
          Manage your procurement tenders efficiently with our comprehensive admin dashboard.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={handleLoginOpen}
          sx={{
            backgroundColor: 'white',
            color: 'black',
            padding: { xs: '10px 30px', sm: '12px 48px' },
            fontSize: { xs: '1rem', sm: '1.2rem' },
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.9)',
              color: '#14532D',
              borderBlockWidth: 1,
              border: "1px solid #0D400F"
            },
            transition: 'all 0.3s ease',
          }}
        >
          Login to Dashboard
        </Button>
      </Box>

      {/* Login Dialog */}
      <Dialog
        open={openLogin}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
          handleLoginClose(e, reason);
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            position: 'relative',
            m: { xs: 2, sm: 4 },
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleLoginClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <AdminLogin onClose={handleLoginClose} />
      </Dialog>
    </Box>
  );
};

export default Welcome;
